/**
 * 常量定义
 */
export const KEYBOARD = {
    ENTER: 'Enter',
    ARROW_UP: 'ArrowUp',
    ARROW_DOWN: 'ArrowDown',
    ESC: 'Escape',
} as const;

export const ICON_TYPES = {
    DROPDOWN: 'DropDown',
    CLOSE: 'Close',
} as const;
